// extracted by mini-css-extract-plugin
export default {"changelog":"frontPageMain_changelog__3pxcL","article":"frontPageMain_article__QBq15"};